import {db} from "@/main";
import { FirestoreDataConverter, collection, getDocs} from "firebase/firestore";


const holidayConverter: FirestoreDataConverter<NEWDay> = {
    toFirestore(data: NEWDay) {
        return {
            data
        };
    },
    fromFirestore(snapshot): NEWDay {
        const data = snapshot.data();
        return {
            ...data,
            Date: new Date(data.Date),
        } as NEWDay;
    }
};

export function GetCalendarDataForYear(year: string): Promise<NEWDay[]> {
    return new Promise<NEWDay[]>((resolve, reject) => {
        const calendarRef = collection(db, "calendarData", year, "calendar").withConverter(holidayConverter);
        const calendarData: NEWDay[] = [];
        
        getDocs(calendarRef)
            .then((querySnapshot) => {
                querySnapshot.forEach((doc) => {
                    calendarData.push(doc.data());
                });
                resolve(calendarData);
            })
            .catch((error) => {
                reject(`Error fetching calendar data: ${error}`);
            });
    });
}